/* eslint camelcase: 0 */

import { Model, createMessages } from '@/helpers/Model'


export class DashboardLKModel extends Model<unknown> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    index: 'Информационная панель',
  });
}
